// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__34OdP","inner":"Footer_inner__1JUI7","nextIcon":"Footer_nextIcon__1xxjm","innerLeft":"Footer_innerLeft__2AQdN"};